import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Toaster, toast } from 'react-hot-toast'

function Credenciales() {
    axios.defaults.withCredentials = true;
    const [datos, setDatos] = useState({
        correo: '',
        nuecontra: '',
        repcontra: ''
    });
    const captureInp = (e) =>{
        e.persist();
        setDatos({...datos, [e.target.name]: e.target.value});
    };
    useEffect(()=>{
        axios.get(`${process.env.REACT_APP_HTTPS}/api/estable/cambiocredenciales`)
        .then(res => {
            setDatos({...datos, correo: res.data});
        }).catch(err => {
            console.log(err);
            return
        });
    },[])

    const CambiarCredenciales = async (uso) =>{
        switch (uso) {
            case 'Contrasena':
                const contranueva = datos.nuecontra;
                const repeticion = datos.repcontra;
                if (contranueva != repeticion) { 
                    toast.error('Las contraseñas no coinciden', {position:'top-center'})
                    return
                };
                axios.post(`${process.env.REACT_APP_HTTPS}/api/estable/cambiocredenciales`, {uso: uso, correo: datos.correo, new: contranueva})
                .then(res => {
                    toast.success(res.data.message, {position:'top-center'});
                }).catch(err => {
                    toast.error(err.data.message, {position:'top-center'});
                    console.log(err);
                    return
                });
                break;
            case 'Correo':
                axios.post(`${process.env.REACT_APP_HTTPS}/api/estable/cambiocredenciales`, {uso: uso, correo: datos.correo})
                .then(res => {
                    toast.success(res.data.message, {position:'top-center'});
                }).catch(err => {
                    toast.error(err.data.message, {position:'top-center'});
                    console.log(err);
                    return
                });
                break;
            default:
                console.log('Uso incorrecto')
                break;
        }
    }

  return (
    <div><br/>
        <div className="Camb_cambio">
            <h2>Cambio de contraseña</h2> <br/>
                <p>Nueva contraseña: </p>
                <input className="loguser" onChange={captureInp} type="password" name="nuecontra" /> <br />
                <p>Repetir contraseña: </p>
                <input className="logpass" onChange={captureInp} type="password" name="repcontra" /> <br />
                <button onClick={() => CambiarCredenciales('Contrasena')} style={{width:'250px'}}>Cambiar contraseña</button> <br/>
        </div>
        <div className="Camb_cambio">
            <h2>Cambio de correo</h2> <br/>
                <p>Correo asociado: </p>
                <input className="loguser" onChange={captureInp} type="text" name="correo" value={datos.correo}/> <br />
                <button onClick={() => CambiarCredenciales('Correo') } style={{width:'250px'}}>Cambiar correo</button> <br/>
        </div>
    <Toaster/>
    </div>
  )
}

export default Credenciales